import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { textSizes } from 'theme/media'
import { colors, IStyles } from '../../theme'

const touchEditorStyles: IStyles = {
    modalWrapper: {
        ...grid.full,
        ...grid.rowCenter,
        ...item.blackOpacity,
    },
    modalInner: {
        ...grid.w90,
        ...item.white,
        ...item.shadowModal,
        ...item.rounded_full_mini,
        ...item.overNone,
        maxWidth: 900,
        padding: 30,
    },
    wrapper: {
        ...grid.col,
        ...grid.fullHeight,
        ...item.overNone,
        ...grid.p_md,
    },
    header: {
        fontSize: textSizes.md,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    footer: {
        ...grid.row,
        ...grid.center,
        ...grid.p_md,
    },
    settings: {
        ...grid.row,
        ...grid.full,
        ...grid.mb_md,
        ...grid.mt_mdPlus,
    },
    emptyMessage: {
        ...grid.colCenter,
        ...grid.full,
        fontSize: textSizes.md,
    },
    tabs: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 30,
    },
    tab: {
        display: 'flex',
        padding: 20,
        justifyContent: 'center',
        width: '49.5%',
        border: `1px solid ${colors.greyBorder}`,
        borderRadius: 7,
        cursor: 'pointer',
        transition: 'all 0.3s',

        '&:hover': {
            backgroundColor: colors.greyBorder,
        },
    },
    activeTab: {
        backgroundColor: colors.greyBorder,
    },
    table: {
        width: '100%',
        marginTop: 24,
    },
    row: {
        cursor: 'pointer',
        transition: 'background 0.3s',

        '&:hover': {
            backgroundColor: colors.grey,
        },
    },
    cell: {
        border: `1px solid ${colors.grey}`,
        padding: 14,
    },
    innerWrapper: {
        height: '90vh',
        overflow: 'auto',
    },
    close: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
}

addStyles(touchEditorStyles)
export default touchEditorStyles
